module.exports = __webpack_public_path__ + "static/media/coupon-icon-inactive.128428f9.svg";